//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {isNullOrEmpty, fromJsonString, getProp} from '@nuskin/ns-common-lib';
import {events} from '@nuskin/ns-util';

export default {
  name: 'BundleProduct',
  props: {
    bundleProduct: {
      type: Object,
      default: () => ({})
    },
    quantity: {
      type: Number,
      default: 0
    },
    market: {
      type: String,
      default: 'US'
    },
    language: {
      type: String,
      default: 'en'
    },
    parentProduct: {
      type: Object,
      default: () => ({})
    },
    subscriptionPriceLabel: {
      type: String,
      default: ''
    },
    showLabels: {
      type: Boolean,
      default: false
    },
    configuration: {
      type: Object,
      default: () => ({})
    },
    isLoggedIn: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: () => ({})
    },
    showWholeSalePricing: {
      type: Boolean,
      default: false
    },
    isWholesale: {
      type: Boolean,
      default: false
    },
    isDistributor: {
      type: Boolean,
      default: false
    },
    isPreferredCustomer: {
      type: Boolean,
      default: false
    },
    isOptional: {
      type: Boolean,
      default: false
    },
    currency: {
      type: String,
      default: 'USD'
    }
  },
  data() {
    return {
      currentVariantSku: '',
      updatedBundleVariant: {},
      price: '0',
      priceLabel: 'Retail Price',
      priceType: 'retail',
      originalPrice: '0',
      originalPriceLabel: 'Original Price',
      originalPriceType: 'wholesale',
      subscriptionPrice: '2',
      currencyCode: 'USD',
      salesEvent: '',
      activeSalesEvents: [],
      optionalIsSelected: false
    };
  },
  computed: {
    variant() {
      const variants = this.bundleProduct.variants || [];
      const updatedVariant = !isNullOrEmpty(this.updatedBundleVariant)
        ? this.updatedBundleVariant
        : null;
      return updatedVariant || variants[0];
    },
    variantSku() {
      return (this.variant || {}).sku;
    },
    imgData() {
      const prop = this.getProductImageData(this.bundleProduct);
      const propUrl = (prop || {}).url || null;
      const propAlt = (prop || {}).alt || null;
      const pbv = this.updatedBundleVariant; // product bundle variant (pbv)
      if (!isNullOrEmpty(pbv)) {
        const isProductBundleImageUrlExist =
          pbv &&
          pbv.productImages &&
          pbv.productImages[0] &&
          pbv.productImages[0].url
            ? pbv.productImages[0].url
            : null;
        const isProductBundleImageAltExist =
          pbv &&
          pbv.productImages &&
          pbv.productImages[0] &&
          pbv.productImages[0].alt
            ? pbv.productImages[0].alt
            : null;
        return {
          url: isProductBundleImageUrlExist || propUrl,
          alt: isProductBundleImageAltExist || propAlt
        };
      }
      return {url: propUrl, alt: propAlt};
    },
    textData() {
      const prop = this.getProductTextData(this.bundleProduct);
      const propTitle = (prop || {}).title || null;
      const propLabel = (prop || {}).label || null;
      const variantStatement =
        `${this.$t('selectVariant')}:` || 'Select Your Option:';
      const pbv = this.updatedBundleVariant; // product bundle variant (pbv)
      const bundleProductHasMoreThanOneVariant =
        this.bundleProduct &&
        this.bundleProduct.variants &&
        this.bundleProduct.variants.length > 1;
      if (!isNullOrEmpty(pbv)) {
        const isPbvTitleExist = pbv && pbv.title ? pbv.title : null;
        const isPbvLabelExist =
          pbv && pbv.variantLabel ? pbv.variantLabel : null;
        return {
          title: isPbvTitleExist || propTitle,
          statement: bundleProductHasMoreThanOneVariant
            ? variantStatement
            : null,
          label: bundleProductHasMoreThanOneVariant
            ? isPbvLabelExist || propLabel || null
            : null
        };
      }
      return {
        title: propTitle,
        statement: bundleProductHasMoreThanOneVariant ? variantStatement : null,
        label: bundleProductHasMoreThanOneVariant ? propLabel || null : null
      };
    },
    currencyLocale() {
      return this.$store.getters['nuskin/currencyLocale'] || '';
    },
    priceAmount() {
      return this.formatCurrency(this.price);
    },
    originalPriceAmount() {
      return this.formatCurrency(this.originalPrice);
    },
    subscriptionPriceAmount() {
      return this.formatCurrency(this.subscriptionPrice);
    },
    tabletAndUp() {
      return (
        this.$mq === 'tablet' ||
        this.$mq === 'desktop' ||
        this.$mq === 'desktopHD'
      );
    }
  },
  watch: {
    variantSku: {
      immediate: true,
      handler(value, otherValue) {
        this.currentVariantSku = value || '';
        this.handlePricing();
      }
    }
  },
  mounted() {
    this.addListeners();
  },
  beforeDestroy() {
    this.removeListeners();
  },
  methods: {
    getProductImageData(product) {
      const variants =
        product && product.variants && product.variants.length > 0
          ? product.variants
          : null;
      const variantImageData =
        variants &&
        variants[0].productImages &&
        variants[0].productImages[0] &&
        variants[0].productImages[0].url // eslint-disable-next-line prettier/prettier
          ? {url: variants[0].productImages[0].url, alt: variants[0].productImages[0].alt}
          : null;
      const productImageData =
        product &&
        product.productImages &&
        product.productImages.length > 0 &&
        product.productImages[0].url // eslint-disable-next-line prettier/prettier
          ? {url: product.productImages[0].url, alt: product.productImages[0].alt}
          : null;
      return variantImageData || productImageData || null;
    },
    getProductTextData(product) {
      const variants =
        product && product.variants && product.variants.length > 0
          ? product.variants
          : null;
      const variantTitle =
        variants && variants[0].title ? variants[0].title : null;
      const variantLabel =
        variants && variants[0].variantLabel ? variants[0].variantLabel : null;
      const productTitle =
        product && product.title ? product.title : {url: null, alt: null};
      const productLabel =
        product && product.variantSelectLabel
          ? product.variantSelectLabel
          : null;
      const variantStatement =
        `${this.$t('selectVariant')}:` || 'Select Your Option:';
      return {
        title: variantTitle || productTitle || null,
        statement: variants && variants.length > 1 ? variantStatement : null,
        label:
          variants && variants.length > 1
            ? variantLabel || productLabel || null
            : null
      };
    },
    handleNewVariantSelected({updatedVariant, oldSku}) {
      this.updatedBundleVariant = updatedVariant;
      this.currentVariantSku = updatedVariant.sku;
      this.$emit('bundle-update', {
        newSku: updatedVariant.sku,
        oldSku,
        isRemoveOldSku: !!oldSku && updatedVariant.sku !== oldSku,
        isAddNewSku: oldSku.length > 0 && updatedVariant.sku !== oldSku,
        isOptional: this.isOptional
      });
    },
    formatCurrency(value) {
      const withQuantity = parseFloat(value) * parseFloat(this.quantity);
      if (!this.currencyCode || !this.currencyLocale) {
        console.warn(
          `[Catalog] Currency unknown. Code ['USD']: '${this.currencyCode}', Locale ['en-US']: '${this.currencyLocale}'.`
        );
      }
      return Intl.NumberFormat(this.currencyLocale || 'en-US', {
        style: 'currency',
        currency: this.currencyCode || 'USD',
        currencyDisplay: 'narrowSymbol'
      }).format(typeof withQuantity === 'object' ? 0 : withQuantity || 0);
    },
    handlePricing() {
      if (!this.variantSku || !this.variant) {
        console.warn(
          // eslint-disable-next-line max-len
          'Cannot handle sales event logic for this variant within BundleProducts.vue (i.e. BundleProduct.vue), no variantSku and/or variant defined within this BundleProduct.vue.'
        );
        return;
      }

      const pricing = fromJsonString(this.variant.pricingJson, {});

      let salesEvent = '';
      for (const activeSalesEvent of this.activeSalesEvents) {
        // get sales event pricing
        let retailPrice = getProp(
          pricing,
          `retail.${activeSalesEvent}.price`,
          null
        );
        retailPrice = isNullOrEmpty(retailPrice) ? null : retailPrice;

        let wholesalePrice = getProp(
          pricing,
          `wholesale.${activeSalesEvent}.price`,
          null
        );
        wholesalePrice = isNullOrEmpty(wholesalePrice) ? null : wholesalePrice;

        let wholesaleCv = getProp(
          pricing,
          `wholesale.${activeSalesEvent}.cv`,
          null
        );
        wholesaleCv = isNullOrEmpty(wholesaleCv) ? null : wholesaleCv;

        let wholesalePv = getProp(
          pricing,
          `wholesale.${activeSalesEvent}.pv`,
          null
        );
        wholesalePv = isNullOrEmpty(wholesalePv) ? null : wholesalePv;

        if (retailPrice || wholesalePrice || wholesaleCv || wholesalePv) {
          this.updatedBundleVariant.price[activeSalesEvent] = {
            retail: retailPrice,
            wholesale: wholesalePrice
          };

          if (!this.updatedBundleVariant.points) {
            this.updatedBundleVariant.points = {};
          }
          this.updatedBundleVariant.points[activeSalesEvent] = {
            wholesale: {
              cv: wholesaleCv,
              pv: wholesalePv
            }
          };

          salesEvent = activeSalesEvent;
        }
      }

      this.salesEvent = salesEvent;

      const priceKey = this.isWholesale ? 'wholesale' : 'retail';
      const subscriptionPriceKey = this.isWholesale
        ? 'wholesaleSubscription'
        : 'retailSubscription';

      this.price = this.salesEvent
        ? ((this.variant.price || {})[this.salesEvent] || {})[priceKey]
        : (this.variant.price || {})[priceKey];

      this.originalPrice =
        this.isWholesale || this.salesEvent
          ? (this.variant.price || {}).retail
          : null;

      this.subscriptionPrice = (this.variant.price || {})[subscriptionPriceKey];

      this.priceLabel = this.handlePriceLabel();
      this.priceType = this.handlePriceType();
      this.originalPriceLabel = this.handleOriginalPriceLabel();
      this.originalPriceType = this.handleOriginalPriceType();
      this.currencyCode =
        (this.variant.price || {currencyCode: 'USD'}).currencyCode ||
        this.currency;
    },
    handlePriceLabel() {
      if (this.salesEvent) {
        return this.isWholesale
          ? this.$t('price.wholesaleSales')
          : this.$t('price.retailSales');
      }
      return this.isWholesale
        ? this.$t('price.wholesale')
        : this.$t('price.retail');
    },
    handlePriceType() {
      if (this.salesEvent) {
        return this.isWholesale ? 'wholesaleSales' : 'retailSales';
      }
      return this.isWholesale ? 'wholesale' : 'retail';
    },
    handleOriginalPriceLabel() {
      return this.isWholesale || this.salesEvent ? this.$t('price.retail') : '';
    },
    handleOriginalPriceType() {
      return this.isWholesale || this.salesEvent ? 'retail' : '';
    },
    handleActiveSalesEvents(activeSalesEvents) {
      this.activeSalesEvents = activeSalesEvents || [];
      this.handlePricing();
    },
    handleCardClick() {
      this.$emit('bundle-update', {
        newSku: this.currentVariantSku,
        oldSku: this.currentVariantSku,
        isRemoveOldSku: !this.isOptional
          ? false
          : !!(this.optionalIsSelected && this.isOptional),
        isAddNewSku: !this.isOptional
          ? false
          : !!(!this.optionalIsSelected && this.isOptional),
        isOptional: this.isOptional
      });
      this.optionalIsSelected = !this.isOptional
        ? true
        : !this.optionalIsSelected;
    },
    /**
     * Subscribe to events, should only be called when mounted
     */
    addListeners() {
      events.getValue(
        events.salesevent.ACTIVE_EVENTS,
        this.handleActiveSalesEvents,
        true // subscribe
      );
    },
    /**
     * Unsubscribe from events, should only be called when destroyed
     */
    removeListeners() {
      // stop listening to active sales events
      events.unsubscribe(
        events.salesevent.ACTIVE_EVENTS,
        this.handleActiveSalesEvents
      );
    }
  }
};
